<template>
    <div class="c-form" @submit="submit">
        <div class="c-form__title">
          {{ $t('landing.login.title') }}
        </div>
        <div class="c-form__wrapper" v-bind:class="{ 'is-loading': isLoading }">
            <form class="c-form__form">
                <p class="c-form__field" v-bind:class="{ 'has-error': hasError('username') }">
                    <label
                        class="c-form__label"
                        for="username">
                        {{ $t('landing.register_form.email.label') }}
                    </label>
                    <input
                      v-model="username"
                      class="c-form__input"
                      type="email"
                      name="username"
                      id="username"
                      required>
                      <span
                        v-if="hasError('username')"
                        class="c-form__error">
                          {{ $t('errors.login.username') }}
                      </span>
                </p>
                <p class="c-form__field" v-bind:class="{ 'has-error': hasError('password') }">
                    <label
                        class="c-form__label"
                        for="passoword">
                        {{ $t('landing.login.password.label') }}
                      </label>
                    <input
                        v-model="password"
                        class="c-form__input"
                        :type="passwordType"
                        name="passoword"
                        id="passoword"
                        required>
                    <span
                        class="c-form__unmask-pwd"
                        :title="$t('landing.register_form.unmask')"
                        v-on:click="toggleMask">
                    </span>
                    <span
                      v-if="hasError('password')"
                      class="c-form__error">
                        {{ $t('errors.login.password') }}
                    </span>
                </p>
                <p class="c-form__options">
                    <router-link :to="{name: 'rememberPassword'}"
                      href="#" class="c-form__link c-form__link--remember"
                      :title="$t('landing.login.remember_pwd')">
                          {{ $t('landing.login.remember_pwd') }}
                    </router-link>
                </p>
                <p class="c-form__actions">
                    <input
                    class="c-form__submit"
                    type="submit"
                    :value="$t('landing.login.submit.text')">
                </p>
            </form>
        </div>
    </div>
</template>

<script>
export default {
  name: 'LoginForm',
  props: {
    onSubmit: {
      type: Function,
      required: true,
    },
    errors: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data() {
    return {
      username: '',
      password: '',
      unMask: false,
    }
  },
  computed: {
    passwordType() {
      return this.unMask ? 'text' : 'password'
    },
  },
  methods: {
    submit(e) {
      e.preventDefault()
      this.onSubmit(this.$data, e)
    },
    toggleMask() {
      this.unMask = !this.unMask
    },
    hasError(prop) {
      return prop in this.errors
    },
  },
}
</script>
